import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Card, BlockHeader, Row, Col, Pagination } from '@teko/ui';
import { reviewMock } from './mock.es.js';
import { OverallRating } from './components/OverallRating/OverallRating.es.js';
import { ReviewForm } from './components/ReviewForm/ReviewForm.es.js';
import { ReviewLine } from './components/ReviewLine/ReviewLine.es.js';

const ReviewWrapper = styled.div``;
const StyledContainer = styled.div`
  border-top: 1px solid rgb(224, 224, 224);
  padding: 16px;
`;
const StyledPaginationBlock = styled.div`
  position: relative;
  width: fit-content;
  margin-left: auto;
  margin-right: 20px;
  padding-bottom: 20px;
`;
const ProductReview = ({
  review = reviewMock,
  showForm = false,
  onSendRating,
  ratingPage,
  onPageChanged,
  pageLimit = 10
}) => {
  return /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(ReviewWrapper, null, /* @__PURE__ */ React.createElement(BlockHeader, {
    title: t("Nh\u1EADn x\xE9t v\xE0 \u0111\xE1nh gi\xE1")
  }), /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    col: 3
  }, /* @__PURE__ */ React.createElement(OverallRating, {
    average: review.average,
    totalRating: review.totalRating,
    statisticVotes: review.statisticVotes
  }), showForm && /* @__PURE__ */ React.createElement(ReviewForm, {
    onSendRating: (rating, comment) => onSendRating(rating, comment)
  })), /* @__PURE__ */ React.createElement(Col, {
    col: 9
  }, review && review.totalRating > 0 && review.items.map((item) => {
    return /* @__PURE__ */ React.createElement(ReviewLine, {
      key: item.createdAt,
      rating: item.rating,
      comment: item.comment,
      time: item.createdAt
    });
  })))), review && review.totalRating > 0 && /* @__PURE__ */ React.createElement(StyledPaginationBlock, null, /* @__PURE__ */ React.createElement(Pagination, {
    totalRecords: review.totalRating,
    pageLimit,
    onPageChanged: (page) => onPageChanged(page),
    currentPage: ratingPage
  }))));
};

export { ProductReview };
